import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';
import { getProfileTypes } from '../service';
import Button from './common/button';
import { RadioSelect } from './common';

export default function ChangeProfileType({
  groupColumn,
  onSubmit = () => {},
  closePopup = () => {}
}) {
  const { t } = useTranslation();
  const [profileTypes, setProfileTypes] = useState([]);
  const [selectedProfileType, setSelectedProfileType] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  console.log(groupColumn);

  const fetchProfileTypes = async () => {
    try {
      setIsLoading(true);
      const { data: profileTypesList } = await getProfileTypes();

      const formattedProfileTypes = profileTypesList.map((profileType) => ({
        _id: profileType._id,
        label: profileType.name,
        value: profileType._id
      }));

      setProfileTypes(formattedProfileTypes);

      // Set the first profile type as default if available
      if (formattedProfileTypes.length > 0) {
        setSelectedProfileType(formattedProfileTypes[0].value);
      }
    } catch (error) {
      toast.error('Failed to get profile types');
      console.error('Failed to get profile types: ', error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchProfileTypes();
  }, []);

  const handleSubmit = () => {
    if (!selectedProfileType) {
      toast.error('Please select a profile type');
      return;
    }

    // Call the onSubmit callback
    onSubmit(
      groupColumn._id,
      profileTypes.find((type) => type.value === selectedProfileType)
    );

    // Close the popover
    closePopup();
  };

  return (
    <div>
      <header className="bg-[#F8F8F8] px-6 py-4 rounded-t-lg flex flex-col items-start justify-start">
        <h4 className="font-semibold">{t('changeProfileType.title', 'Change Profile Type')}</h4>
        <p className="text-sm">
          {t('changeProfileType.for', 'For')}{' '}
          <span className="font-semibold underline">{groupColumn?.name}</span>
        </p>
      </header>
      <main className="p-6">
        <div>
          <RadioSelect
            label={t('changeProfileType.selectType', 'Select Profile Type')}
            options={profileTypes}
            selected={selectedProfileType}
            onChange={(value) => setSelectedProfileType(value)}
          />

          <div className="flex justify-end gap-3 mt-6">
            <Button.ButtonOutlined type="button" onClick={closePopup} disabled={isLoading} isMini>
              {t('changeProfileType.cancel', 'Cancel')}
            </Button.ButtonOutlined>

            <Button.ButtonFilled
              type="button"
              onClick={handleSubmit}
              disabled={isLoading || !selectedProfileType}
              isMini>
              {t('changeProfileType.save', 'Save')}
            </Button.ButtonFilled>
          </div>
        </div>
      </main>
    </div>
  );
}
